import { PropTypes } from 'react';

const Table = ({ children }) => (
    <table className="cn-table ttd-table" id="all-tickets">
        {children}
    </table>
);

Table.propTypes = {
    children: PropTypes.node
};

export default Table;



// WEBPACK FOOTER //
// ./app/components/table/index.jsx